(function () {
  var desktopQuery = window.matchMedia('(min-width: 768px)');
  var productCache = new Map();
  var activeRequest = null;

  function publish(eventName, parameters) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, parameters);
    } else if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, parameters));
    }
  }

  function searchUrl(query) {
    return theme.routes.search_url + '?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=hide&sort_by=relevance&q=' + encodeURIComponent(query);
  }

  function renderProducts(container, html, query, gender, strictQuery) {
    var preview = container.querySelector('[data-search-discovery-preview]');
    var target = container.querySelector('[data-search-discovery-products]');
    var title = container.querySelector('[data-search-discovery-preview-title]');
    var viewAll = container.querySelector('[data-search-discovery-view-all]');
    var parser = new DOMParser();
    var responseDocument = parser.parseFromString(html, 'text/html');
    var sourceList = responseDocument.querySelector('#predictive-search-results');
    var candidates = sourceList ? Array.prototype.slice.call(sourceList.querySelectorAll('.product-block:not(.page-block):not(.collection-block)')) : [];
    var cards = candidates.filter(function (card) {
      var wrapper = card.closest('[data-dclare-product-gender]');
      return wrapper && wrapper.getAttribute('data-dclare-product-gender') === gender;
    }).slice(0, 4);

    title.textContent = (gender === 'women' ? 'Women · ' : 'Men · ') + query;
    viewAll.textContent = 'View all';
    viewAll.href = searchUrl(strictQuery);

    if (!cards.length) {
      target.innerHTML = '<p class="dclare-search-discovery__preview-status">No direct product match. Use “View all” to continue searching.</p>';
      preview.setAttribute('aria-busy', 'false');
      return;
    }

    var productList = document.createElement('div');
    productList.className = sourceList.className;
    cards.forEach(function (card) {
      card.querySelectorAll('.btn.quickbuy-toggle').forEach(function (button) { button.remove(); });
      card.querySelectorAll('.quickbuy-toggle').forEach(function (link) { link.classList.remove('quickbuy-toggle'); });
      card.removeAttribute('data-cc-animate');
      card.classList.add('main-search-result');
      productList.appendChild(card);
    });

    target.replaceChildren(productList);
    preview.setAttribute('aria-busy', 'false');

    if (window.theme && theme.ProductBlockManager && window.jQuery) {
      theme.ProductBlockManager.loadImages(window.jQuery(target));
    }
  }

  function loadProducts(chip) {
    if (!desktopQuery.matches) return;

    var container = chip.closest('[data-search-discovery-context="overlay"]');
    if (!container) return;

    var query = chip.getAttribute('data-search-discovery-query');
    var strictQuery = chip.getAttribute('data-search-discovery-search-query') || query;
    var gender = chip.getAttribute('data-search-discovery-gender');
    var preview = container.querySelector('[data-search-discovery-preview]');
    var target = container.querySelector('[data-search-discovery-products]');
    var title = container.querySelector('[data-search-discovery-preview-title]');

    container.querySelectorAll('.dclare-search-discovery__chip').forEach(function (item) {
      item.classList.toggle('is-active', item === chip);
    });

    preview.hidden = false;
    preview.setAttribute('aria-busy', 'true');
    title.textContent = 'Loading ' + query + '…';

    if (productCache.has(strictQuery)) {
      renderProducts(container, productCache.get(strictQuery), query, gender, strictQuery);
      return;
    }

    if (activeRequest) activeRequest.abort();
    activeRequest = new AbortController();

    var endpoint = new URL(theme.routes.predictive_search_url, window.location.origin);
    endpoint.searchParams.set('q', strictQuery);
    endpoint.searchParams.set('section_id', 'predictive-search');
    endpoint.searchParams.set('resources[type]', 'product');
    endpoint.searchParams.set('resources[limit]', '10');
    endpoint.searchParams.set('resources[options][unavailable_products]', 'hide');
    endpoint.searchParams.set('resources[options][fields]', 'title,product_type,tag,variants.title,vendor');

    fetch(endpoint.toString(), { signal: activeRequest.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Search request failed');
        return response.text();
      })
      .then(function (html) {
        productCache.set(strictQuery, html);
        renderProducts(container, html, query, gender, strictQuery);
      })
      .catch(function (error) {
        if (error.name === 'AbortError') return;
        target.innerHTML = '<p class="dclare-search-discovery__preview-status">Related products could not load. Use “View all” to continue.</p>';
        preview.setAttribute('aria-busy', 'false');
      });
  }

  function initialize(root) {
    root.querySelectorAll('[data-search-discovery-context="overlay"]').forEach(function (container) {
      if (container.dataset.searchDiscoveryReady === 'true') return;
      container.dataset.searchDiscoveryReady = 'true';

      container.querySelectorAll('.dclare-search-discovery__chip').forEach(function (chip) {
        chip.addEventListener('pointerenter', function () { loadProducts(chip); });
        chip.addEventListener('focus', function () { loadProducts(chip); });
      });
    });
  }

  document.addEventListener('click', function (event) {
    var searchOpen = event.target.closest('.show-search-link');
    if (searchOpen) {
      publish('search_overlay_open', { location: 'header' });
      return;
    }

    var discoveryLink = event.target.closest('[data-search-discovery-link]');
    if (discoveryLink) {
      publish('search_discovery_click', {
        discovery_type: discoveryLink.getAttribute('data-search-discovery-link'),
        gender: discoveryLink.getAttribute('data-search-discovery-gender') || 'all',
        item_label: discoveryLink.getAttribute('data-search-discovery-query')
      });
      return;
    }

    var predictiveResult = event.target.closest('.main-search__results .main-search-result, [data-search-discovery-products] .main-search-result');
    if (predictiveResult) {
      publish('predictive_search_result_click', {
        result_type: predictiveResult.classList.contains('main-search-result--page') ? 'suggestion' : 'product'
      });
    }
  });

  document.addEventListener('DOMContentLoaded', function () { initialize(document); });
  document.addEventListener('shopify:section:load', function (event) { initialize(event.target); });
})();
